<div class="d-flex flex-column align-items-center">
  <div class="card mt-5 col-md-6 p-4 mr-0 p-gutter flex-auto max-w-[700px]" style="height: 500px; overflow-y: auto;">
    <div class="d-flex flex-column align-items-end" (click)="close()"> <span style="cursor: pointer;">&times;</span>
    </div>
    <h5>{{text}} Category</h5>
    <form class="mr-0 d-flex flex-column align-items-center" (ngSubmit)="submitCategoryMapping()">
      <div class="mb-3 mr-0 col-md-10">
        <label class="form-label">Category</label>
        <input type="text" class="form-control" [(ngModel)]="selectedCategoryMap.categoryID"
          [ngModelOptions]="{ standalone: true }" [disabled]="text !== 'Add'">
      </div>

      <div class="mb-3 mr-0 col-md-10">
        <label class="form-label">Examination Status</label>
        <input type="text" >
        <ng-select class="form-select" [(ngModel)]="selectedCategoryMap.examStatus"
        [ngModelOptions]="{ standalone: true }">
          <ng-option value="Pending">Pending</ng-option>
          <ng-option value="InProgress">In Progress</ng-option>
          <ng-option value="Finished">Finished</ng-option>
          <ng-option value="TimeElapsed">Time Elapsed</ng-option>
          <ng-option value="Stopped">Stopped</ng-option>
          <ng-option value="Disqualified">Disqualified</ng-option>
        </ng-select>
      </div>

      <button class="btn btn-primary btn-lg col-md-10" type="submit">Save</button>
    </form>
  </div>
</div>